import * as CoreFns from './CoreFns';

export function searchEntity(currentList, entityType){

	var toCheck = ['fe', 'pu'];
	var set = [];
	toCheck.forEach((aSSet, index0)=>{

		var fe = currentList[aSSet];
		if (fe){
			var feKeys = Object.keys(fe);

			feKeys.forEach((aFEKey, index)=>{

				var setX = searchPage(fe[aFEKey], [aSSet, aFEKey], entityType, false, currentList);
				set = set.concat(setX);
			})			
		}

	})

	var s1 = searchFooter(currentList.fo, ['fo'], entityType);
	set = set.concat(s1);

	return set;
}

export function searchPage(thisPage, thisPagePath, entityType, checkNavBarEvenIfNotOn, currentList){
	var set = [];
	var nvAdd = searchNavBar(thisPage.nv, thisPagePath.concat(['nv']), entityType, checkNavBarEvenIfNotOn, currentList);
	set = set.concat(nvAdd);
	var screens = thisPage._s;
	var screenKeys = Object.keys(screens);
	screenKeys.forEach((aScreenKey, index)=>{
		var thisScreen = screens[aScreenKey];
		var thisScreenPath = thisPagePath.concat(['_s', aScreenKey]);
		var pp = searchPanel(thisScreen, thisScreenPath, entityType);
		set = set.concat(pp);
	})
	return set;
}


export function searchFooter(thisScreen, thisScreenPath, entityType){
	var itemPath = thisScreenPath.concat(['i']);
	if (thisScreen){
		var items = thisScreen.i;
		return searchItem(items, itemPath, entityType);		
	}else{
		return [];
	}
}

export function searchNavBar(nv, thisScreenPath, entityType, checkNavBarEvenIfNotOn, currentList){
	var toAdd = [];
	if (nv.on || (checkNavBarEvenIfNotOn && nv.i)){
		var gotError = false;
		if (nv.on && nv.on !== 1){
			thisScreenPath = ['cn', nv.on, 'nv'];
			try{
				nv = CoreFns.goDownPath(currentList, thisScreenPath);		
			}catch(err){
				gotError = true;
			}
		}
		if (nv.on || gotError){
		}else{
			var p0 = searchItem(nv.i, thisScreenPath.concat(['i']), entityType);
			toAdd = toAdd.concat(p0);
			if (nv.navbarCluster){
				var p1 = searchItem(nv.ic, thisScreenPath.concat(['ic']), entityType);
				var p2 = searchItem(nv.ir, thisScreenPath.concat(['ir']), entityType);
				toAdd = toAdd.concat(p1).concat(p2);
			}

		}
	}
	return toAdd;
}


export function searchPanel(thisScreen, thisScreenPath, entityType){
	var set = [];
	if (entityType === 'PANEL'){
		set = set.concat({path:thisScreenPath, item:thisScreen});
	}
	var alerts = thisScreen.al;
	if (alerts){
		var alertKeys = Object.keys(alerts);
		alertKeys.forEach((anAlertKey, index3)=>{
			var path = thisScreenPath.concat(['al', anAlertKey]);
			var thisAlert = alerts[anAlertKey];
			if (entityType === 'ALERT'){
				set = set.concat({path, item:thisAlert});

			}
			var alertItemPath = path.concat(['k']);
			var relItems3 = thisAlert.k;
			var set3 = searchItem(relItems3, alertItemPath, entityType);
			set = set.concat(set3);

		})		
	}



	var itemPath = thisScreenPath.concat(['i']);
	var items = thisScreen.i;
	var set1 = searchItem(items, itemPath, entityType);

	var relItemPath = thisScreenPath.concat(['k']);
	var relItems = thisScreen.k;
	var set2 = searchItem(relItems, relItemPath, entityType);

	set = set.concat(set1).concat(set2);
	return set;
}

export function searchItem(cardItems, path, entityType){
	var net = [];
	if (cardItems){
		var cardItemKeys = Object.keys(cardItems);
		cardItemKeys.forEach((aCardItemKey, index)=>{
			var thisItem = cardItems[aCardItemKey];
			var tt = thisItem.t;
			if (tt === entityType){
				net.push({path:path.concat([aCardItemKey]), item:thisItem});
			}else if (CoreFns.isHolder(tt)){
				var pp = searchItem(thisItem.i, path.concat([aCardItemKey, 'i']), entityType);
				net = net.concat(pp);
			}
			if (CoreFns.gotTextX(tt) && entityType === 'RICHTEXT'){
				var p1 = searchThroughItemX(thisItem.x, path.concat([aCardItemKey, 'x']));
				net = net.concat(p1);
			}
		})		
	}
	return net;
}

function searchThroughItemX(itemX, path){
	var net = [];
	for (var i = 0; i < itemX.length; i++){
		var anItem = itemX[i];
		if (anItem.t === 'tb' || anItem.t === 'h' || anItem.t === 'br'){
		}else if (anItem.t === 'a'){
			net.push({item:anItem, path:path.concat([i])});
		}else{
			console.warn(anItem);
		}
	}
	return net;
}
